<template>
	<HeaderBar
		theme="risque-pro"
		:service-title="$t('components.layout.appHeader.title')"
		:home-link="link"
	>
		<HeaderMenu v-if="!maintenance" />
	</HeaderBar>
</template>

<script lang="ts">
	import Vue from 'vue';
	import Component from 'vue-class-component';

	import HeaderMenu from './HeaderMenu.vue';

	declare const QRP_MAINTENANCE: string;

	/** The Header of the application */
	@Component({
		components: {
			HeaderMenu
		}
	})
	export default class AppHeader extends Vue {
		get link(): string|boolean {
			return this.maintenance ? false : this.$t('components.layout.appHeader.logoBtn.link') as string;
		}

		get maintenance(): boolean {
			return QRP_MAINTENANCE === 'true';
		}
	}
</script>
